<template>
  <div class="container permissions">
    <v-select
      :items="permission"
      label="Permission Group"
      item-text="name"
      item-value="id"
      v-model="selected"
      @change="getPermission"
    ></v-select>
  </div>
</template>

<script>
import permission from "./permission.controller.js";

export default {
  name: "PermissionsSelector",
  route: {
    name: "permissionsSelector",
    path: "/permissionsSelector",
  },
  components: {},
  data() {
    return {
      selected: {},
      permission: [
        {
          roles: [
            {
              role: "Admin",
              selected: false,
            },
          ],
          organizations: [
            {
              organization: "Admin",
              selected: false,
            },
          ],
          name: "",
          id: "",
        },
      ],
    };
  },
  mounted() {
    this.getAll();
  },
  props: ["selectedValue"],
  watch: {
    selectedValue: function (newVal) {
      this.selected = newVal;
    },
  },
  computed: {},
  methods: {
    getPermission(value) {
      this.selected = value;
    },
    sendPermissions(){
      return this.selected
    },
    async getAll() {
      this.permission = await permission.getAll();
    },
  },
};
</script>

<style lang="scss">
.permissions {
  .v-navigation-drawer {
    position: fixed;
    width: 100% !important;
  }
  .v-overlay--active {
    position: fixed;
  }
}
</style>
